export const firebaseData = {
    apiKey: "AIzaSyAmUEkLk7PzWJLnACrIueryt8ubV1FCgOQ",
    authDomain: "quickstart-1550501068702.firebaseapp.com",
    databaseURL: "https://quickstart-1550501068702.firebaseio.com",
    projectId: "quickstart-1550501068702",
    storageBucket: "quickstart-1550501068702.appspot.com",
    messagingSenderId: "419712447770",
    appId: "1:419712447770:web:fdf32bff1133937b8768a3"
};